var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.785 86.2906L4.36834 65.874C2.84966 64.3428 1.99828 62.2731 2 60.1165C2.00902 57.974 2.85959 55.9209 4.36834 54.3998C5.89285 52.8662 7.9634 51.9998 10.1258 51.9906C12.2741 52.0105 14.328 52.8761 15.8425 54.3998L21.1508 59.6673V21.6515C21.0754 19.6618 21.752 17.7167 23.0459 16.2034C24.3398 14.69 26.1561 13.7194 28.1333 13.4848C29.1737 13.424 30.2156 13.5746 31.1963 13.9275C32.1769 14.2803 33.0758 14.8281 33.839 15.5379C34.6021 16.2476 35.2136 17.1045 35.6366 18.057C36.0596 19.0095 36.2852 20.0378 36.3 21.0798V44.1915L56.7167 47.0906C58.5387 47.3465 60.2072 48.2516 61.415 49.6395C62.6229 51.0275 63.289 52.8049 63.2908 54.6448C63.2975 65.3904 60.7946 75.989 55.9817 85.5965L55.6142 86.2906",
  stroke: "#4C525F",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3002 38.7609C38.5063 37.7938 40.5034 36.4069 42.1802 34.6775C44.8542 31.9975 46.6739 28.5851 47.4094 24.8714C48.1449 21.1576 47.7632 17.3092 46.3125 13.8123C44.8618 10.3154 42.4071 7.327 39.2587 5.22455C36.1103 3.12211 32.4094 2 28.6235 2C24.8376 2 21.1367 3.12211 17.9883 5.22455C14.8399 7.327 12.3852 10.3154 10.9345 13.8123C9.48377 17.3092 9.10204 21.1576 9.83755 24.8714C10.5731 28.5851 12.3928 31.9975 15.0668 34.6775C16.7583 36.4081 18.7689 37.7947 20.9877 38.7609",
  stroke: "#4C525F",
  strokeWidth: 3,
  strokeMiterlimit: 10
});

function SvgTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 88,
    viewBox: "0 0 65 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/touch.4b9276c7712f4552e8199dcb4c1764eb.svg";
export { ForwardRef as ReactComponent };